// extracted by mini-css-extract-plugin
export var categoryName = "ProjectCard-module--categoryName--4de00";
export var emailForm = "ProjectCard-module--emailForm--0db75";
export var infoBanner = "ProjectCard-module--infoBanner--071ad";
export var project = "ProjectCard-module--project--ee69f";
export var skillPill = "ProjectCard-module--skillPill--66815";